class DagiProductGallery extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
    this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
    this.prev = this.querySelector('[data-gallery-prev]');
    this.next = this.querySelector('[data-gallery-next]');
    this.index = 0;

    if (this.slides.length <= 1) {
      this.prev?.setAttribute('hidden', '');
      this.next?.setAttribute('hidden', '');
      return;
    }

    this.prev?.addEventListener('click', () => this.go(this.index - 1));
    this.next?.addEventListener('click', () => this.go(this.index + 1));

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const nextIndex = Number(thumb.dataset.index);
        if (!Number.isNaN(nextIndex)) this.go(nextIndex);
      });
    });
  }

  go(nextIndex) {
    const total = this.slides.length;
    this.index = (nextIndex + total) % total;

    this.#pauseVideos();

    this.slides.forEach((slide, i) => {
      const active = i === this.index;
      slide.classList.toggle('is-active', active);
      slide.toggleAttribute('hidden', !active);
    });

    this.thumbs.forEach((thumb, i) => {
      const active = i === this.index;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  #pauseVideos() {
    this.querySelectorAll('video').forEach((video) => {
      video.pause();
    });

    this.querySelectorAll('iframe').forEach((iframe) => {
      const src = iframe.getAttribute('src');
      if (src) {
        iframe.setAttribute('src', src);
      }
    });
  }
}

if (!customElements.get('dagi-product-gallery')) {
  customElements.define('dagi-product-gallery', DagiProductGallery);
}
